import { Button, Form, Input, InputNumber, Select, Spin } from "antd";
import { filterOption, fiscalCodeField, requiredField } from "../common/common";
import { useEffect, useState } from "react";
import axiosInstance from "../common/api";
import { useNavigate, useParams } from "react-router";

export default function () {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [dataLoading, setDataLoading] = useState(false);
  const { id } = useParams();
  const onFinish = (data) => {
    setLoading(true);
    axiosInstance
      .put(`doctor/${id}`, data)
      .then(() => navigate(-1))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    setDataLoading(true);
    axiosInstance
      .get(`doctor/${id}`)
      .then(({ data }) => form.setFieldsValue(data))
      .finally(() => setDataLoading(false));
  }, []);

  return (
    <Spin spinning={dataLoading}>
      <Form form={form} onFinish={onFinish} layout="vertical" autoComplete="off">
        <Form.Item label="Nome" rules={[requiredField]} name="firstName">
          <Input />
        </Form.Item>
        <Form.Item label="Cognome" rules={[requiredField]} name="lastName">
          <Input />
        </Form.Item>
        <Form.Item label="Codice fiscale" name="fiscalCode" rules={[fiscalCodeField]}>
          <Input />
        </Form.Item>
        <Form.Item
          label="E-mail"
          name="email"
          rules={[{ type: "email", message: "E-mail non valida" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Numero di telefono"
          name="phoneNumber"
          rules={[
            { pattern: /^[0-9].{9}$/, message: "Numero non valido. Rimuovere eventuali spazi" },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Conferma
          </Button>
        </Form.Item>
      </Form>
    </Spin>
  );
}
